/*eslint-disable */
import {mapGetters} from 'vuex';
import {
  bus
} from '@/main';
export default {
  name: 'briefcase-activity-log',
  components: {},
  props: [],
  data () {
    return {
      briefcaseActivityLogData:null,
      briefcaseActivityLogDataResults:[],
      selfUserInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfoFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getBriefcaseActivityLogFun(){
      return this.$store.getters.briefcaseActivityLogGetters
    }
  },
  mounted () {
  },
  created(){
   this.$store.dispatch('getbriefcaseActivityLogAction')
  },
  methods: {
    briefcaseStorageBreakdownFun(){
      bus.$emit('normalBriefcaseViewStateBus', true)
      bus.$emit('briefcaseActivityLogStateBus', false)
    },
    trimDecimalVal(num){
      if(num){
        return (num).toFixed(2);
      }
    }
  },
  watch:{
    getBriefcaseActivityLogFun(newVal, oldVal){
      if(!newVal) return;
      this.briefcaseActivityLogData = newVal.data
      this.briefcaseActivityLogDataResults = this.briefcaseActivityLogData.results
    },
    getSelfUserInfoFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
  }
}